import { render, staticRenderFns } from "./BaseTableSelectActions.vue?vue&type=template&id=1aada473&scoped=true&"
import script from "./BaseTableSelectActions.vue?vue&type=script&lang=js&"
export * from "./BaseTableSelectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aada473",
  null
  
)

export default component.exports